import { render } from "./breaks.vue?vue&type=template&id=2736a006"
import script from "./breaks.vue?vue&type=script&lang=js"
export * from "./breaks.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__